import React, { useState } from "react";
import Block from "../Block";

type Props = {
  returnObj: number[][];
  showProcess: Boolean;
  reachedHere: number[] | undefined;
  progress: number;
  difficulty: "EASY" | "MEDIUM" | "HARD";
};
function Board({
  returnObj,
  showProcess,
  reachedHere,
  progress,
  difficulty,
}: Props) {
  console.log("POPS " + returnObj);
  console.log("HERE " + reachedHere);
  const dToCol = {
    EASY: "lightgreen",
    MEDIUM: "rgb(11, 178, 255)",
    HARD: "#fd0094",
  };
  const perToCol = {
    0: "#c49fff",
    1: "#7b2df8",
    2: "#ff52e2",
    3: "#fd0094",
  };
  const getStyle = () => {
    let bg = "";
    if (progress <= 10) {
      bg = "white";
    } else if (progress <= 30) {
      bg = "#c49fff";
    } else if (progress <= 60) {
      bg = "#7b2df8";
    } else if (progress <= 90) {
      bg = "#ff52e2";
    } else {
      bg = "#fd0094";
    }
    return {
      width: progress + "%",
      background: bg,
      boxShadow: bg,
    };
  };
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
      <div
        className="SudokuBoard"
        style={{
          border: "2px solid black",
        }}
      >
        {returnObj.map((row, rowNum) => (
          <div className="SudokuBoardRow">
            {row.map((block, colNum) => (
              <Block
                block={block}
                colNum={colNum}
                rowNum={rowNum}
                reachedHere={reachedHere}
                key={rowNum + "," + colNum}
              />
            ))}
          </div>
        ))}
      </div>
      <div
        style={{
          color: "white",
          fontFamily: "var(--font-general)",
          display: "flex",
        }}
      >
        Sudoku Difficulty
        <div style={{ color: dToCol[difficulty], marginLeft: "3px" }}>
          {difficulty}
        </div>
      </div>
      <div
        style={{
          color: "white",
          fontFamily: "var(--font-general)",
          display: "flex",
        }}
      >
        Progress {Math.ceil(progress)}%
      </div>
      <div className="progress">
        <div className="progress-value" style={getStyle()}></div>
      </div>
    </div>
  );
}

export default Board;
